import AdHeader from '@/components/adHeader';
import {
    getGarageDetailsByCity,
    getGarageDetailsById,
    getReviewsCity,
} from '@/components/fakeDoor/api';
import {
    getGarageId,
    mapCityWithGarage,
} from '@/components/fakeDoor/constants';
import { SeoPages } from '@/components/seoPages';
import Breadcrumbs from '@/components/seoPages/Breadcrumbs';
import Footer from '@/components/seoPages/Footer';
import { StaticExploreCta } from '@/components/staticExploreCta/StaticExploreCta';
import { getEntriesCms } from '@/utils/strapi';
import { useShowCtaAfterFold } from '@/hooks/useShowCtaAfterFold';
import { useContext, useEffect, useState } from 'react';
import { DeviceContext } from '@/pages/_app';
import { CustomerBodyStyle } from './[garageOrBrand]';
import { useRouter } from 'next/router';
import MetaTags from '@/components/DefaultMetaTags';
import NotFound from '@/pages/404';
import { replaceFieldsWithValues } from '@/components/seoPages/replaceFieldsWithValues';
import { GetServerSideProps } from 'next';
import BottomNavigation from '@/components/BottomNavigation';
import { loadGrowthbookFeatures, getFeatureValue } from '@/utils/growthbook';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_FAKEDOOR_LANDING } from '@/analytics/events';
import { HOSTNAME } from '@/lib/constants';
import { HOSTNAME as HOSTNAMEWITHOUTPREFIX } from '@/constants/constantsAckoDrive';
import {
    fetchAppointmentDetailsFromOrderId,
    fetchRewardDetails,
    getUserPolicy,
    getPincodeByGarageId,
} from '@/utils/api';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectCardDetails,
    setAppointments,
} from '@/store/modules/appointmentSlice';
import {
    GarageCardDetails,
    IGarageDetails,
    IParsedGarageDetails,
} from '@/types';
import { generateGarageJsonLd } from '@/config/garageJsonLd.config';
import { APPOINTMENT_CARD_TYPE, SEO_URL_TYPE } from '@/constants/enums';
import { getHeaderString } from '@/utils/common';
import { getRewardDetailsFromCoupons } from '@/utils/rewards';
import { AUTH_KEYS, TRACKER_ID } from '@/constants/common';
import { ADSC_BOTTOM_NAV } from '@/constants/featureFlags';
import {
    LOCAL_STORAGE_KEYS,
    SESSION_STORAGE_KEYS,
} from '@/constants/storageKeys';
import { RewardConditions, FetchRewardResponseDto } from '@/types';
import RewardGriefity from '@/components/common/rewardGriefity';
import { DEFAULT_REWARD_DESCRIPTION } from '@/constants/index';
import { authenticationService } from '@/services/authentication_service';
import { getGarageCardDetails } from '@/utils/garage';
import { PAGE_TYPE } from '@/constants/enums';
import { clearPincodeAndGarageIdFromLocalStorage } from '@/utils';
import { useAppBarUpdate } from '@/hooks/useAppBarUpdate';
import { LIGHT_THEME_APPBAR_CONFIG } from '@/config/appbarConfig';

function CitySeoPage(props: any) {
    console.log('City page props ::', props);
    const router = useRouter();
    const isMobileDevice = useContext(DeviceContext)?.isMobile;
    console.log('CitySeoPage props', props);
    const showCta = useShowCtaAfterFold('CarServices');
    const routerQuery = router.query;
    const city = getHeaderString(routerQuery['city']);
    const dispatch = useDispatch();
    const cardData = useSelector(selectCardDetails) || {};
    const garageData: IGarageDetails[] = props?.garageDetails;

    const jsonLd = generateGarageJsonLd(garageData, SEO_URL_TYPE.CITY, city);
    const { utm_medium } = router.query;
    // const [showRewardGriefity, setShowRewardGriefity] = useState(false);

    // useEffect(() => {
    //     const showReward = sessionStorage.getItem(
    //         SESSION_STORAGE_KEYS.BANNER_SHOWN
    //     );
    //     if (showReward) {
    //         setShowRewardGriefity(true);
    //         sessionStorage.removeItem(SESSION_STORAGE_KEYS.BANNER_SHOWN);
    //     }
    // }, []);

    useAppBarUpdate(LIGHT_THEME_APPBAR_CONFIG);

    useEffect(() => {
        clearPincodeAndGarageIdFromLocalStorage();
        if (
            props?.garageId &&
            !props?.isMultipleGarage &&
            !props?.appointmentData?.appointment_id
        ) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.GARAGE_ID, props.garageId);
        }
        if (utm_medium) {
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.UTM_MEDIUM,
                utm_medium as string
            );
        }
    }, [
        props.rewardDetails,
        props.garageId,
        props.isMultipleGarage,
        props.appointmentData?.appointment_id,
    ]);

    const { isCouponAvailable, couponCode, offerDetails } =
        getRewardDetailsFromCoupons(props?.rewardDetails?.coupons);

    useEffect(() => {
        const viewPageLoadEvent = async () => {
            await viewPageAPI({
                event_name: VIEW_PAGE_FAKEDOOR_LANDING,
                customAttributes: {
                    page_type: 'city',
                    show_bottom_nav: props.showBottomNav,
                    is_coupon_available: isCouponAvailable,
                    coupon_code: couponCode,
                    offer_details: offerDetails,
                },
                isFakeDoor: true,
            });
        };
        viewPageLoadEvent();
        if (props?.appointmentData?.garage_id) {
            dispatch(setAppointments(props?.appointmentData));
        }
    }, []);

    if (props?.isInvalidCity) {
        return (
            <>
                <CustomerBodyStyle isMobile={isMobileDevice} />
                <NotFound />
            </>
        );
    }

    return (
        <>
            <MetaTags
                pathname={`${city}`}
                title={replaceFieldsWithValues(
                    props?.garageSeoCommonsdata?.locationMetaTitle,
                    {
                        location: props.city,
                    }
                )}
                description={replaceFieldsWithValues(
                    props?.garageSeoCommonsdata?.locationMetaDescription,
                    {
                        location: props.city,
                    }
                )}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Corporation',
                        name: 'ACKO Drive',
                        url: 'https://ackodrive.com/',
                        logo: 'https://ackodrive-assets.s3.amazonaws.com/media/Ackodrive_2023_Color.png',
                        contactPoint: {
                            '@type': 'ContactPoint',
                            telephone: '18002662250',
                            contactType: 'customer service',
                            areaServed: 'IN',
                            availableLanguage: ['en', 'Hindi'],
                        },
                        sameAs: [
                            'https://www.facebook.com/ackodrive/',
                            'https://www.instagram.com/ackodrive/',
                            'https://twitter.com/ackodrive',
                        ],
                    }),
                }}
            />
            {jsonLd && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(jsonLd),
                    }}
                />
            )}
            <CustomerBodyStyle isMobile={isMobileDevice} />
            <AdHeader
                hideHamburgerMenu={false}
                isMobileDevice={true}
                hideShadow={true}
            />
            {props?.garageSeoCommonsdata?.ReusableComponents?.map(
                (ReusableComponent: any, index: number) => {
                    return (
                        <section
                            id={ReusableComponent.componentName}
                            key={ReusableComponent.componentName}
                        >
                            <SeoPages
                                ReusableComponent={ReusableComponent}
                                cardData={cardData}
                                {...props}
                            />
                        </section>
                    );
                }
            )}
            <Breadcrumbs
                list={[
                    { displayName: 'Home', link: `${HOSTNAMEWITHOUTPREFIX}/` },
                    {
                        displayName: 'Service Centre',
                        link: `${HOSTNAME}`,
                    },
                    {
                        displayName: `${props.city}`,
                        link: `${HOSTNAME}/${city}`,
                    },
                ]}
            />
            {props.showBottomNav ? (
                <BottomNavigation />
            ) : (
                showCta && (
                    <StaticExploreCta
                        targetId="CarServices"
                        withHeader={true}
                        hasCardData={
                            !!cardData && !!Object.keys(cardData).length
                        }
                    />
                )
            )}
            {/* {showRewardGriefity && (
                <RewardGriefity
                    title={''}
                    description={DEFAULT_REWARD_DESCRIPTION}
                    couponCode={''}
                    setShowReward={setShowRewardGriefity}
                    showReward={showRewardGriefity}
                    showCouponCode={false}
                />
            )} */}
            <Footer cities={props?.garageSeoCommonsdata?.liveCities} />
        </>
    );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
    const { query = {}, req } = context || {};
    let city = (query?.city as string) || '';
    city = city
        ?.replace(/-/g, ' ')
        ?.split(' ')
        ?.map(
            (word) =>
                word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
        )
        ?.join(' ');

    const userId =
        getHeaderString(req.headers[AUTH_KEYS.X_USER_ID]) ||
        getHeaderString(req.headers[TRACKER_ID]);
    await loadGrowthbookFeatures(userId);
    const showBottomNav = getFeatureValue({ flagName: ADSC_BOTTOM_NAV });

    let garageSeoCommonsdata: any = await getEntriesCms(
        `garage-seo-commons`,
        'live',
        'createdAt',
        999,
        '',
        '',
        '',
        true
    );

    let tempLiveCities = garageSeoCommonsdata?.[0]?.attributes?.liveCities;
    if (!tempLiveCities[(query?.city as string)?.toLowerCase()]) {
        return {
            props: {
                garageSeoCommonsdata: [],
                isCity: true,
                city,
                garageSeoManualdata: {},
                garageList: {},
                garageData: [],
                isInvalidCity: true,
            },
        };
    }

    let route = `service-centre/${query?.city}`;
    let garageSeoManualdata: any = {};
    if (route) {
        garageSeoManualdata = await getEntriesCms(
            `garage-seo-manual-contents`,
            'live',
            'createdAt',
            999,
            'url',
            '$eq',
            route,
            true
        );
    }

    let n = [];
    let u = [...garageSeoCommonsdata?.[0]?.attributes.ReusableComponents];
    n = u.find((x) => x.componentName === 'Faq');
    let tempshowQuestions = Number(n?.showQuestions);
    if (garageSeoManualdata?.[0]?.attributes?.Faqs) {
        let tempData = garageSeoManualdata?.[0]?.attributes.Faqs;
        n = tempData;
        let len = Math.ceil(tempData?.Faqs?.length / tempshowQuestions);
        let rdm = Math.floor(Math.random() * len);
        tempData = {
            ...tempData,
            Faqs: tempData.Faqs.splice(
                rdm * tempshowQuestions,
                tempshowQuestions
            ),
        };
        if (garageSeoManualdata?.[0]?.attributes) {
            garageSeoManualdata[0].attributes.Faqs = tempData;
        }
    }

    const urlGarage =
        await mapCityWithGarage[(query?.city as string)?.toLowerCase()];
    const currentGarageId = await getGarageId(urlGarage);
    let garageData: any = await getEntriesCms(
        `acko-garages`,
        'live',
        'createdAt',
        999,
        `garageId`,
        '$eq',
        `${currentGarageId}`,
        false,
        ['garageId'],
        [
            'servicing_brands',
            'servicing_brands.company_image_url',
            'garage_review_ratings',
            'garage_review_ratings.reviews',
        ]
    );

    let reviewData: any = await getReviewsCity(currentGarageId);

    let garageList: IParsedGarageDetails[] = await getGarageDetailsByCity(
        (query?.city as string)?.toLowerCase() === 'bangalore'
            ? 'bengaluru'
            : (query?.city as string)?.toLowerCase() === 'new-delhi'
              ? 'new delhi'
              : (query?.city as string),
        true
    );

    const garageIds = garageList.map((garage) => garage.garageId);
    const garageDetails: IGarageDetails[] = await Promise.all(
        garageIds.map((garageId) => getGarageDetailsById(garageId))
    );

    const appointmentData = await fetchAppointmentDetailsFromOrderId(
        context.req,
        query?.appointmentId
    );

    const userPolicyType = await getUserPolicy(context.req);

    let rewardDetails: FetchRewardResponseDto | undefined;

    const data: RewardConditions = {
        garage_id: currentGarageId,
    };

    rewardDetails = await fetchRewardDetails(context.req, data);

    const isLoggedInServerSide = authenticationService.isLoggedInServerBrowser(
        context.req,
        context.res
    );

    let garageCardDetails: GarageCardDetails[] = [];

    const garageCardDetailsPromises = garageIds.map(async (garageId) => {
        const pincodeResponse = await getPincodeByGarageId(
            garageId,
            context.req
        );
        if (pincodeResponse?.pincode) {
            return getGarageCardDetails(
                garageId,
                pincodeResponse.pincode,
                context.req as any
            );
        }
        return [];
    });

    const garageCardDetailsArrays = await Promise.all(
        garageCardDetailsPromises
    );
    garageCardDetails = garageCardDetailsArrays.flat();

    garageCardDetails.sort((a, b) => {
        if (a.garageId === currentGarageId) return -1;
        if (b.garageId === currentGarageId) return 1;
        return 0;
    });

    const isMultipleGarage = garageCardDetails.length > 1;
    const pincodeResponse = await getPincodeByGarageId(
        currentGarageId,
        context.req
    );
    const pincode = pincodeResponse?.pincode;

    return {
        props: {
            garageSeoCommonsdata: garageSeoCommonsdata?.[0]?.attributes || [],
            isCity: true,
            city,
            garageSeoManualdata: garageSeoManualdata?.[0]?.attributes || {},
            garageList: garageList || {},
            garageData: garageData?.[0]?.attributes || [],
            reviewData: reviewData || {},
            garageDetails: garageDetails || [],
            showBottomNav: showBottomNav,
            query,
            appointmentData: appointmentData || {},
            rewardDetails: rewardDetails || {},
            garageId: currentGarageId,
            isLoggedInServerSide: isLoggedInServerSide,
            userPolicyType: userPolicyType || {},
            garageCardDetails: garageCardDetails || [],
            isMultipleGarage: isMultipleGarage,
            garageIds: garageIds,
            pincode: pincode,
            pageType: PAGE_TYPE.CITY_PAGE,
        },
    };
};

export default CitySeoPage;
